import { render } from "./ContextMenuItem.vue?vue&type=template&id=4200a0a0&ts=true"
import script from "./ContextMenuItem.vue?vue&type=script&lang=ts"
export * from "./ContextMenuItem.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Code\\GitHub\\vue3-context-menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__